import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsRealtimeListComponent } from './transport-interventions-realtime-list.component';
import {DxButtonModule, DxDropDownButtonModule, DxListModule} from 'devextreme-angular';
import { TransportInterventionsRealtimeListItemComponent } from './transport-interventions-realtime-list-item/transport-interventions-realtime-list-item.component';
import {BadgeModule} from 'shared';
import {TransportInterventionsRealtimeReportModule} from '../transport-interventions-realtime-report/transport-interventions-realtime-report.module';



@NgModule({
  declarations: [TransportInterventionsRealtimeListComponent, TransportInterventionsRealtimeListItemComponent],
    imports: [
        CommonModule,
        DxListModule,
        DxButtonModule,
        DxDropDownButtonModule,
        BadgeModule,
        TransportInterventionsRealtimeReportModule
    ],
  exports: [TransportInterventionsRealtimeListComponent, TransportInterventionsRealtimeListItemComponent]
})
export class TransportInterventionsRealtimeListModule { }
